import {put, delay, takeEvery, select, call, all} from "redux-saga/effects";
import SettingsAction from "../settings/settingsAction";
import FavoritesAction from "./favoritesAction";

import fakeFavoritesProfiler from "../../mock/favorites/profiler.json";
import fakeFavoritesWebint from "../../mock/favorites/webint.json";
import {apiCaseService, apiProfileService} from "../../config/api";

function* getFavoritesSaga(action) {
  console.log('getFavoritesSaga', action);
  const {targetType, callback} = action.payload;
  try {
    const {data} = yield apiCaseService.getAllFavoriteTargets(targetType?.toUpperCase());
    /*let data = [];
    if (targetType === 'profiler') {
      data = fakeFavoritesProfiler;
    } else {
      data = fakeFavoritesWebint;
    }*/

    yield put(FavoritesAction.updateFavoritesState({favorites: data}))
    yield delay(1000);

    callback(data);

  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}


function* setFavoritesSaga(action) {
  const {targetId, targetType, flag, callback} = action.payload;
  try {
    const {data} = yield apiCaseService.setFavorite({targetId, isFavorite: flag, module: targetType});

    callback(data);

  } catch (e) {
    yield put(SettingsAction.handleAPIError(e));
  }
}

export function* watchFavorites() {
  yield takeEvery(FavoritesAction.GET_FAVORITES, getFavoritesSaga);
  yield takeEvery(FavoritesAction.SET_FAVORITES, setFavoritesSaga);
}
